import { render, staticRenderFns } from "./duicards.vue?vue&type=template&id=4f1959e3&scoped=true"
import script from "./duicards.vue?vue&type=script&lang=js"
export * from "./duicards.vue?vue&type=script&lang=js"
import style0 from "./duicards.vue?vue&type=style&index=0&id=4f1959e3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f1959e3",
  null
  
)

export default component.exports